const API_ROOTS = {
    PRODUCTION: 'https://gateway-mobile.prod.rnwl-backend-services.rnwl.cloud',
}
const API_ROOT = API_ROOTS.PRODUCTION

module.exports = { API_ROOT }
